import {
  AppUpdate,
  AppUpdateAvailability,
} from '@capawesome/capacitor-app-update';
import { Drawer, Box, Typography, Button } from '@mui/material';
import { PropsWithChildren } from 'react';
import useAppUpdate from 'src/common/hooks/useAppUpdate';
import { useNavigate } from 'react-router-dom';
import { SECONDARY_LOGO } from 'src/common/constants/brand';

export default function AppUpdateGuard({ children }: PropsWithChildren) {
  const navigate = useNavigate();

  const { updateInfo } = useAppUpdate();

  const isUpdateAvailable =
    updateInfo?.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE;

  const handleClose = () => {
    navigate(-1);
  };

  const openAppStore = async () => {
    await AppUpdate.openAppStore();
  };

  return isUpdateAvailable ? (
    <Drawer
      onClose={handleClose}
      open={true}
      SlideProps={{ timeout: 20 }}
      variant="persistent"
      sx={{
        width: '100%',
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          minWidth: '100vw',
          top: 0,
          border: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: (theme) => theme.palette.background.paper,
          minHeight: '100vh',
        },
      }}
    >
      <img
        style={{
          position: 'absolute',
          height: '50%',
          bottom: 0,
          objectFit: 'cover',
        }}
        src={'/icons/campana.png'}
      />
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent={'start'}
        m="auto"
        height="100%"
        width="100%"
        zIndex={(theme) => theme.zIndex.drawer}
      >
        <Box
          width="70%"
          maxWidth="70%"
          ml={3}
          height={'calc(70vw * 0.7)'}
          overflow={'hidden'}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <img src={SECONDARY_LOGO} alt="pari logo" width="100%" />
        </Box>
        <Typography
          variant="body1"
          color="primary"
          textAlign="left"
          fontFamily="Gotham"
          fontWeight={400}
          fontSize="1.5rem!important"
          mb={1}
        >
          ¡Actualiza tu app!
        </Typography>
        <Typography
          variant="body1"
          textAlign="center"
          fontSize={'16px!important'}
          fontFamily="BentonSans"
          fontWeight={700}
          lineHeight={'20px'}
          mb={5}
          sx={{ maxWidth: '265px' }}
        >
          Antes de continuar, actualiza tu app para disfrutar de la mejor
          experiencia.
        </Typography>
        <Button
          onClick={openAppStore}
          variant="contained"
          color="primary"
          size="large"
          sx={{
            fontFamily: 'BentonSans',
            fontSize: '12px',
            fontWeight: 700,
            mx: 'auto',
            px: 3,
          }}
        >
          Actualizar
        </Button>
        <Button
          onClick={handleClose}
          variant="text"
          color="greyText"
          size="large"
          sx={{
            fontFamily: 'BentonSans',
            fontSize: '12px',
            fontWeight: 700,
            mx: 'auto',
            px: 3,
          }}
        >
          Regresar
        </Button>
      </Box>
    </Drawer>
  ) : (
    children
  );
}
